import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'localizedValue',
    pure: false,
    standalone: false
})
export class LocalizedValuePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(item: any, englishField: string = 'value', czechField: string = 'cz_value'): string {
    if (!item) return '';

    const currentLang = this.translate.getCurrentLang() || 'en';

    if (currentLang === 'cz') {
      return (
        item[czechField] ||
        item[englishField] || // if there is no cz value
        ''
      );
    }
    return item[englishField] || '';
  }
}
